<template>
  <el-dialog
          :title="'黑名单'"
          :close-on-click-modal="false"
          :visible.sync="visible"
  style="text-align: left">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm"
             label-width="150px">
      <el-form-item label="姓名" prop="xm">
        <el-input v-model="dataForm.xm" clearable></el-input>
      </el-form-item>
      <el-form-item label="性别" prop="xb" >
        <el-select v-model="dataForm.xb" clearable placeholder="请选择性别">
          <el-option label="男" value="1"></el-option>
          <el-option label="女" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="身份证号码" prop="sfzhm">
        <el-input v-model="dataForm.sfzhm" clearable></el-input>
      </el-form-item>
      <el-form-item label="证件地址" prop="zjdz">
        <el-input v-model="dataForm.zjdz" clearable></el-input>
      </el-form-item>
      <el-form-item label="原因" prop="reason">
        <el-input v-model="dataForm.inBlackListReason" clearable></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {

    data () {
      const validateNumber = (rule, value, callback) => {
        var patrn = /^\d+(\.\d+)?$/;
        if (!patrn.exec(value)) {
          callback(new Error('请填写数字'))
        } else {
          callback()
        }
      }
      return {
        form: {
          name:''

        },
        equips:[],
        loading:false,
        visible: false,
        dictionaryData:[],
        useridList:[],
        menuList: [],
        customerList:[],
        dataForm: {
          xb: '',
          xm: '',
          sfzhm: '',
          zjdz: '',
          inBlackListReason: ''
        },
        types: [],
        fileList:[],
        fileList2:[],
        currentPage: 1,
        total:0,
        uploadUrl:'',
        dataListSelections:[],
        dataRule: {
          xm: [
            {
              required: true,
              message: "请填写姓名",
              trigger: ["blur", "change"],
            },
          ],sfzhm: [
            {
              required: true,
              message: "请填写身份证号",
              trigger: ["blur", "change"],
            },
            { validator: this.isCardID, trigger: ["blur", "change"] },
          ],
        }
      }
    },
    created(){
    },
    methods: {

      init (id) {
        this.visible = true
        this.$nextTick(() => {
          console.log('11111111111111111111')
          this.$refs['dataForm'].resetFields()

        })

      },
      isCardID(rule, value, callback) {
        if (!/(^\d{15}$)|(^\d{17}(\d|X|x)$)/.test(value)) {
          callback(new Error("身份证长度或格式错误"));
          return;
        }
        //身份证城市
        var aCity = {
          11: "北京",
          12: "天津",
          13: "河北",
          14: "山西",
          15: "内蒙古",
          21: "辽宁",
          22: "吉林",
          23: "黑龙江",
          31: "上海",
          32: "江苏",
          33: "浙江",
          34: "安徽",
          35: "福建",
          36: "江西",
          37: "山东",
          41: "河南",
          42: "湖北",
          43: "湖南",
          44: "广东",
          45: "广西",
          46: "海南",
          50: "重庆",
          51: "四川",
          52: "贵州",
          53: "云南",
          54: "西藏",
          61: "陕西",
          62: "甘肃",
          63: "青海",
          64: "宁夏",
          65: "新疆",
          71: "台湾",
          81: "香港",
          82: "澳门",
          91: "国外",
        };
        if (!aCity[parseInt(value.substr(0, 2))]) {
          callback(new Error("身份证地区非法"));
          return;
        }

        // 出生日期验证
        var sBirthday = (
                        value.substr(6, 4) +
                        "-" +
                        Number(value.substr(10, 2)) +
                        "-" +
                        Number(value.substr(12, 2))
                ).replace(/-/g, "/"),
                d = new Date(sBirthday);
        if (
                sBirthday !=
                d.getFullYear() + "/" + (d.getMonth() + 1) + "/" + d.getDate()
        ) {
          callback(new Error("身份证上的出生日期非法"));
          return;
        }
        // this.xzyh.csrq = (d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate())}

        // 身份证号码校验
        var sum = 0,
                weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2],
                codes = "10X98765432";
        for (var i = 0; i < value.length - 1; i++) {
          sum += value[i] * weights[i];
        }
        var last = codes[sum % 11]; //计算出来的最后一位身份证号码
        if (value[value.length - 1].toUpperCase() != last) {
          callback(new Error("身份证号非法"));
          return;
        }

        callback();
      },

      dataFormSubmit () {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {

                this.$http({
                  url: '/bjba/yhgl/addBlackUser',
                  method: 'post',
                  data: this.dataForm
                }).then(({data}) => {
                  if (data && data.code === 200) {
                    this.$message({
                      message: '操作成功',
                      type: 'success',
                      duration: 1500
                    })
                    this.visible = false
                    this.$emit('refreshDataList')
                  } else if(data && data.code === 500) {
                    this.$message({
                      message: data.message,
                      type: 'error',
                      duration: 1500
                    })
                  }
                })


          }
        })
      }
    }
  }
</script>
